"use strict";

exports.__esModule = true;
exports.HistoricalDataItemChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Utils = require("../../../../Utils");
var _DataAccessorContext = require("../../../API/DataInterface/DataAccessorContext");
var _AsyncLoader = require("../../../Core/AsyncLoader");
var _LoadingMediator = require("../../../Core/LoadingMediator");
var _DeviceContext = require("../../../Device/DeviceContext");
var _TimeSeriesLineChart = require("../../../Recharts/Charts/TimeSeriesLineChart");
var _TimeSeriesScatterChart = require("../../../Recharts/Charts/TimeSeriesScatterChart");
var _TimeContext = require("../../../Time/TimeContext");
var _buildDeviceDataItemQuery = require("../buildDeviceDataItemQuery");
var _DataItemContextMenu = require("../DataItemContextMenu");
var _helpers = require("./helpers");
var _libCalendar = require("@vimana/lib-calendar");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getXAxisProps = function getXAxisProps(_ref) {
  var selectedInterval = _ref.selectedInterval,
    hideAxis = _ref.hideAxis,
    timezone = _ref.timezone;
  var domain = [selectedInterval.startMillis + (0, _libCalendar.getTimezoneOffsetMillis)(timezone.name, selectedInterval.startMillis), selectedInterval.endMillis + (0, _libCalendar.getTimezoneOffsetMillis)(timezone.name, selectedInterval.endMillis)];
  return {
    domain: domain,
    hide: hideAxis
  };
};
var getYAxisProps = function getYAxisProps(_ref2) {
  var enableYDomain = _ref2.enableYDomain,
    minYValue = _ref2.minYValue,
    maxYValue = _ref2.maxYValue,
    hideAxis = _ref2.hideAxis;
  var domain;
  if (!enableYDomain) {
    domain = ["dataMin", "dataMax"];
  } else {
    domain = [typeof minYValue !== "undefined" ? minYValue : "dataMin", typeof maxYValue !== "undefined" ? maxYValue : "dataMax"];
  }
  return {
    domain: domain,
    hide: hideAxis
  };
};
var HistoricalDataItemChart = exports.HistoricalDataItemChart = function HistoricalDataItemChart(props) {
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var _React$useContext = _react["default"].useContext(_TimeContext.TimeContext),
    timezone = _React$useContext.timezone;
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var selectedInterval = props.selectedInterval,
    chartType = props.chartType,
    dataItems = props.dataItems,
    _props$enableYDomain = props.enableYDomain,
    enableYDomain = _props$enableYDomain === void 0 ? false : _props$enableYDomain,
    minYValue = props.minYValue,
    maxYValue = props.maxYValue,
    _props$hideXAxis = props.hideXAxis,
    hideXAxis = _props$hideXAxis === void 0 ? false : _props$hideXAxis,
    _props$hideYAxis = props.hideYAxis,
    hideYAxis = _props$hideYAxis === void 0 ? false : _props$hideYAxis,
    _props$showReferenceL = props.showReferenceLine,
    showReferenceLine = _props$showReferenceL === void 0 ? false : _props$showReferenceL,
    _props$referenceLineV = props.referenceLineValue,
    referenceLineValue = _props$referenceLineV === void 0 ? 0 : _props$referenceLineV;
  var width = props.width,
    height = props.height;

  // Subtracting the padding from height and width. Under the modern UI the
  // chart card pads it already, so the chart takes the whole space it is given.
  var inset = theme && theme.uiModern ? {
    x: 0,
    y: 0
  } : {
    x: 8,
    y: 4
  };
  width = width - 2 * inset.x;
  height = height - 2 * inset.y;
  var _useState = (0, _react.useState)(width),
    widthForBin = _useState[0],
    setWidthForBin = _useState[1];
  var debounceToSetWidth = (0, _react.useCallback)((0, _Utils.debounce)(function (width) {
    setWidthForBin(width);
  }), []);
  (0, _react.useEffect)(function () {
    debounceToSetWidth(width);
  }, [width]);
  var queries = dataItems.map(function (d) {
    return (0, _buildDeviceDataItemQuery.buildDeviceDataItemQuery)({
      deviceUUID: device.uuid,
      dataItem: d,
      interval: selectedInterval,
      width: widthForBin
    });
  });
  var xAxisProps = getXAxisProps({
    selectedInterval: selectedInterval,
    timezone: timezone,
    hideAxis: hideXAxis
  });
  var yAxisProps = getYAxisProps({
    enableYDomain: enableYDomain,
    minYValue: minYValue,
    maxYValue: maxYValue,
    hideAxis: hideYAxis
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: inset.y + "px " + inset.x + "px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_AsyncLoader.AsyncLoader, {
    load: function load(queries) {
      var allReq = queries.map(function (query) {
        return dataAccessor.getRawConnectData(query);
      });
      return Promise.all(allReq);
    },
    params: queries
  }, function (loaderProps) {
    return /*#__PURE__*/_react["default"].createElement(_LoadingMediator.LoadingMediator, loaderProps, function (data) {
      var formattedData = (0, _helpers.formatMultiDataItemData)({
        data: data,
        dataItems: dataItems,
        timezone: timezone,
        minYValue: enableYDomain ? minYValue : undefined,
        maxYValue: enableYDomain ? maxYValue : undefined
      });
      var _getChartProps = (0, _helpers.getChartProps)({
          formattedData: formattedData,
          dataItems: dataItems
        }),
        tooltipProps = _getChartProps.tooltipProps,
        legendProps = _getChartProps.legendProps;
      return /*#__PURE__*/_react["default"].createElement(_DataItemContextMenu.DataItemContextMenu, {
        data: formattedData,
        width: width,
        height: height
      }, chartType === "LINE_CHART" ? /*#__PURE__*/_react["default"].createElement(_TimeSeriesLineChart.TimeSeriesLineChart, _extends({}, props, {
        width: width,
        height: height,
        data: formattedData,
        legendProps: legendProps,
        tooltipProps: tooltipProps,
        xAxisProps: xAxisProps,
        yAxisProps: yAxisProps,
        showReferenceLine: showReferenceLine,
        referenceLineValue: referenceLineValue
      })) : /*#__PURE__*/_react["default"].createElement(_TimeSeriesScatterChart.TimeSeriesScatterChart, _extends({}, props, {
        width: width,
        height: height,
        data: formattedData,
        legendProps: legendProps,
        tooltipProps: tooltipProps,
        xAxisProps: xAxisProps,
        yAxisProps: yAxisProps
      })));
    });
  }));
};